import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navbar from '../components/Navbar';
import Routes from '../components/Routes';
import Footer from '../components/Footer';
//import * as tourListActions from '../actions/TourListActions';
import ReduxToastr from 'react-redux-toastr';
import FuckTheCookiesLaw from '../components/FuckTheCookieLaw';
import '../css/style.css';
import '../css/less.css';

class App extends Component {

  render() {
      return (
        <div>
          <Navbar />
          <ReduxToastr
                timeOut={4000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar/>
          <div style={{minHeight: 'calc( 100vh - 250px)'}}>
                <Routes />
          </div>
          <Footer/>
          <FuckTheCookiesLaw />
        </div>
    )
  }
}



export default connect(null, null, null, {pure: false })(App)


// WEBPACK FOOTER //
// ./src/containers/App.js